$('.block-product-card').each(function() {

    if ($(window).width() >= global_helpers.defaults.breakpoint_desktop) {
        var card = $(this);

        card.hoverIntent(
            function() {
                card.find('.hidden-content').slideDown(250);
            },
            function() {
                card.find('.hidden-content').slideUp(250);
            }
        );
    }

});
